import { z } from "zod";

export const loginSchema = () => {
  return z.object({
    username: z.string().min(1),
    password: z.string().min(1),
    agreement_id: z.string().optional().nullable(),
    idp: z.string().optional().nullable(),
    integrated_login: z.string().optional().nullable(),
  });
};

export type LoginFormValues = z.infer<ReturnType<typeof loginSchema>>;
